export default "__VITE_ASSET___1RQTD5c__"